<template>
    <WizardTabWithSidebar
        sidebar-background-image="https://superangels.club/wp-content/uploads/2020/07/ESAC_2020_invest_connect_smart_mobility_72dpi_1600x1200_landscape_BACKGROUND_ONLY.jpg">
        <template #main>
            <WizardHeader title="Manager and Beneficial Owner - Address" :icon="UsersIcon"></WizardHeader>
            <ManagerListItem
                class="border-y border-gray-200 px-2 py-2"
                :manager="state.legalProfile.managers[0]"></ManagerListItem>
            <div class="px-4 pt-4 sm:px-6">
                <LegalManagerBeneficialOwnerAddressForm v-model="formValues"></LegalManagerBeneficialOwnerAddressForm>
            </div>
        </template>
        <template #nextButton>
            <BaseButtonPrimary
                :loading="usePersonalAccountDataState().saving"
                :disabled="usePersonalAccountDataState().saving || formState.hasValidationErrors"
                size="lg"
                @click="submit()"
                >{{ $t('widget.save') }}
            </BaseButtonPrimary>
        </template>
        <template #previousButton>
            <BaseButtonMuted size="lg" @click="navigateToPreviousTab()">{{ $t('widget.back') }}</BaseButtonMuted>
        </template>

        <template #sidebar>
            <p class="pb-2 pb-2 text-base text-gray-800">
                {{ $t('esac_widget_sidebar.legal_manager_one_address') }}
            </p>
        </template>
    </WizardTabWithSidebar>
</template>

<script setup lang="ts">
import WizardTabWithSidebar from '../../WizardTabWithSidebar.vue'
import WizardHeader from '../../WizardHeader.vue'
import BaseButtonPrimary from '../../../base/BaseButtonPrimary.vue'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { useLegalAccountFormState } from '../../../../utilities/account/useAccountFormLegal'
import { computed, inject, onMounted, ref } from 'vue'
import { UsersIcon } from '@heroicons/vue/outline'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import ManagerListItem from '../../../account/legal/managers/ManagerListItem.vue'
import LegalManagerBeneficialOwnerAddressForm from './form/LegalManagerBeneficialOwnerAddressForm.vue'
import { putManager } from '../../../../utilities/api'
import { LegalPersonAddress } from './form/forms'

const formState = useLegalAccountFormState()
const state = useLegalAccountDataState()
const { navigateToNextTab, navigateToPreviousTab } = inject('navigation')

const currentManager = computed(() => {
    if (state.legalProfile.managers.length > 0) {
        return state.legalProfile.managers[0]
    }
    return null
})

const formValues = ref<LegalPersonAddress>(new LegalPersonAddress())

onMounted(() => {
    formValues.value = currentManager.value
})

async function submit() {
    const { valid } = await formState.currentForm.validate()
    if (valid) {
        await putManager(currentManager.value.natural_profile_uid, formValues.value)
        navigateToNextTab()
    }
}
</script>

<style scoped></style>
